// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"contact-module--contact-form--PD6A4","details":"contact-module--details--24gPv","btn":"contact-module--btn--2Zl-9"};